import { Spin } from 'antd';
import { useGetEmployeesVacationsQuery } from 'app/services/edpApiV1/substitutions/substitution';
import { useAppSelector } from 'app/store';
import { uiModel } from 'entities/ui';
import { convertDate } from 'shared/helpers/date';
import { ComponentModes } from 'shared/enums';
import style from './index.module.scss';

export const EmployeeVocations = () => {
  const { selectedEymployerId } = useAppSelector(uiModel.Substitutions.selectors.selectSubstitutions);
  const { controlDrawer } = useAppSelector(uiModel.Substitutions.selectors.selectSubstitutions);

  const { data, isFetching } = useGetEmployeesVacationsQuery(selectedEymployerId!, { skip: !selectedEymployerId });

  return selectedEymployerId || controlDrawer?.mode === ComponentModes.edit ? (
    <Spin size="small" spinning={isFetching}>
      {data && data.data.length !== 0 ? (
        <>
          <div>Оформлено отсутствие:</div>
          <ul className={style.employeeVocations}>
            {data?.data.map(item => (
              <li key={item.id}>{`${convertDate(item.startedAt)} - ${convertDate(item.endedAt)}`}</li>
            ))}
          </ul>
        </>
      ) : (
        <></>
      )}
    </Spin>
  ) : (
    <></>
  );
};
